import React from "react";
import TableNFePaymentTotals from "./components/TableNFePaymentTotals";
import AddPayment from "./components/AddPayment";
import PaymentsTable from "./components/PaymentsTable";

import { PaymentContext } from "./context";
import { CreateNFeContext } from "../../Context";

export default () => {
  const createNFeContext = React.useContext(CreateNFeContext);
  const [disabled, setDisabled] = React.useState(false);

  function onChangePayment() {
    const { total_paid, total_nfe } = createNFeContext.nfe;
    const { discount_value } = createNFeContext.nfe.identification;
    
    const left = parseFloat((total_nfe - (discount_value || 0) - total_paid).toFixed(2));
    setDisabled(left <= 0);
  }
  React.useEffect(onChangePayment, [
    createNFeContext.nfe.payments,
    createNFeContext.nfe.total_paid,
    createNFeContext.nfe.identification.discount_value,
  ]);
  return (
    <PaymentContext.Provider value={{ disabled, setDisabled }}>
      <TableNFePaymentTotals />
      <AddPayment />
      <PaymentsTable />
    </PaymentContext.Provider>
  );
};



// WEBPACK FOOTER //
// ./src/views/Fiscal/NFe/Issuer/NFePaymentShipping/Payments/index.jsx